(() => {
    "use strict";
    $("#link_id").mask("0000-0000-0000");
    $("._dob-l10n").mask("00/00/0000");
})();

export {};
